import { render } from "./workflow-review.vue?vue&type=template&id=b561e14c&scoped=true"
import script from "./workflow-review.vue?vue&type=script&lang=js"
export * from "./workflow-review.vue?vue&type=script&lang=js"

import "./workflow-review.vue?vue&type=style&index=0&id=b561e14c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b561e14c"]])

export default __exports__